const SIGN_OUT_REASON_KEY = "signOutReason";

export const SESSION_REPLACED_MESSAGE =
    "You have been signed out because this account signed in elsewhere.";

export const rememberSignOutReason = async (response: Response): Promise<void> => {
    try {
        const body: unknown = await response.clone().json();

        if (
            typeof body === "object" &&
            body !== null &&
            "hint" in body &&
            body.hint === SESSION_REPLACED_MESSAGE
        ) {
            sessionStorage.setItem(SIGN_OUT_REASON_KEY, SESSION_REPLACED_MESSAGE);
        }
    } catch {
        return;
    }
};

export const takeSignOutReason = (): string | null => {
    try {
        const reason = sessionStorage.getItem(SIGN_OUT_REASON_KEY);
        sessionStorage.removeItem(SIGN_OUT_REASON_KEY);
        return reason;
    } catch {
        return null;
    }
};
